export default {
    ListLoading: 'assist:hostManage:ListLoading', // 流加载
    GetList: 'assist:hostManage:getList', // 获取列表
    GETHOST: 'assist:hostManage:getHost', // 存放主机配置
    Modify: 'assist:hostManage:modify', // 修改主机
    Delete: 'assist:hostManage:delete', // 删除主机
    CHANGESTATUS: 'assist:hostManage:changeStatus', // 更改弹窗状态
    CHANGEBULKSTATUS: 'assist:hostManage:changeBulkStatus', // 更改批量更新弹窗状态
    CHANGEADDLISTSTATUS: 'assist:hostManage:changeAddListStatus', // 更改批量添加弹窗状态
    CHANGEADDWORKLISTSTATUS: 'assist:hostManage:changeAddWorkListStatus', // 更改增加work机器弹窗状态
    IPLIST: 'assist:hostManage:ipList', // 保存ip数组
    SERVERINFO: 'assist:hostManage:serverinfo', // 保存ip数组
    SERVERSTATUS: 'assist:hostManage:serverStatus',
    GetListOld: 'assist:hostManage:getListOld',
    PAGETOTAL: 'assist:hostManage:pagetotal',
    SEARCH: 'assist:hostManage:search',
    GETTODAYM: 'assist:gettodaym:status',
    GETTODAYMSTATUS: 'assist:gettodaymstatus:status',
    GETTOMORROWM: 'assist:gettomorrowm:status',
    GETTOMORROWMSTATUS: 'assist:gettomorrowmstatus:status',
};



// WEBPACK FOOTER //
// ./pages/assist/hostManage/constant.js